import { api } from "./client";

export type ReportStatus = "pending" | "running" | "completed" | "failed";

export type ReportSummary = {
  report_id: string;
  user_id: string;
  user_email: string;
  brand_name: string;
  nice_classes: number[];
  recommendation: string;
  conflicts_count: number;
  created_at: string;
  s3_key: string;
  pdf_key?: string;
  status?: ReportStatus;
  error?: string;
  started_at?: string;
  completed_at?: string;
};

export async function listReports(): Promise<ReportSummary[]> {
  const { data } = await api.get<{ reports: ReportSummary[] }>("/reports");
  return data.reports;
}

export async function getReport(reportId: string): Promise<{
  report: ReportSummary;
  markdown: string | null;
  pdfUrl: string | null;
}> {
  const { data } = await api.get<{
    report: ReportSummary;
    download_url?: string;
    pdf_url?: string;
  }>(`/reports/${reportId}`);
  // Markdown is only available once the pipeline completes.
  let markdown: string | null = null;
  if (data.download_url) {
    const mdResp = await fetch(data.download_url);
    markdown = await mdResp.text();
  }
  return { report: data.report, markdown, pdfUrl: data.pdf_url ?? null };
}
